import React, { useEffect, useRef } from 'react';
import CanvasJSReact from "@canvasjs/react-charts";

const { CanvasJSChart } = CanvasJSReact;

const DoughnutChart = ({ QuizzData, currentQuestionIndex }) => {
    const chartContainerRef = useRef(null);

    useEffect(() => {
        if (chartContainerRef.current) {
            const totalQuestions = QuizzData?.length || 0;
            const answeredQuestions = currentQuestionIndex + 1;
            const remainingQuestions = totalQuestions - answeredQuestions;

            const chart = new CanvasJSReact.CanvasJS.Chart(chartContainerRef.current, {
                animationEnabled: true,
                subtitles: [
                    {
                        text: `${remainingQuestions} / ${totalQuestions}`,
                        verticalAlign: "center",
                        fontSize: 15,
                        fontWeight: 600,
                        fontColor: "#62636C",
                    },
                ],
                data: [
                    {
                        type: "doughnut",
                        innerRadius: "90%",
                        startAngle: 180,
                        dataPoints: [
                            { y: remainingQuestions, color: "#b3b6b9" },
                            { y: answeredQuestions, color: "#576FA8" }, 
                        ],
                    },
                ],
            });

            chart.render();
        }
    }, [QuizzData, currentQuestionIndex]);

    return (
        <div ref={chartContainerRef} style={{ height: "70px", width: "100%" }} />
    );
};

export default DoughnutChart;
